import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function InvSearchPrint(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    const num = 12;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={13} docNamePdf={"InvoicesReport.pdf"} docName={"InvoicesReport"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
